import { createFeatureSelector, createSelector } from '@ngrx/store';

import { OrganizationsState } from './organizations.state';

export const ORGANIZATIONS_STATE_NAME = '[organizations] organizations';

const selectOrganizationsState = createFeatureSelector<OrganizationsState>(
	ORGANIZATIONS_STATE_NAME,
);
export const selectOrgLoading = createSelector(
	selectOrganizationsState,
	(state) => state.loading,
);

export const selectOrganizationById = createSelector(
	selectOrganizationsState,
	(state) => state.organization,
);
export const selectRestoreForm = createSelector(
	selectOrganizationsState,
	(state) => state.restoreForm,
);
export const selectOrghub = createSelector(
	selectOrganizationsState,
	(state) => state.orghub,
);
export const selectCnpjAvailability = createSelector(
	selectOrganizationsState,
	(state) => state.cnpjAvailability,
);
export const selectAddressResult = createSelector(
	selectOrganizationsState,
	(state) => state.address,
);
export const selectCities = createSelector(
	selectOrganizationsState,
	(state) => state.cities,
);
export const selectAuxCities = createSelector(
	selectOrganizationsState,
	(state) => state.auxCities,
);
export const selectOrgRegistration = createSelector(
	selectOrganizationsState,
	(state) => state.registration,
);
export const selectPartners = createSelector(
	selectOrganizationsState,
	(state) => state.partners,
);
export const selectPartner = createSelector(
	selectOrganizationsState,
	(state) => state.partner,
);
export const selectBenefits = createSelector(
	selectOrganizationsState,
	(state) => state.benefits,
);
export const selectBenefit = createSelector(
	selectOrganizationsState,
	(state) => state.benefit,
);
export const selectPositions = createSelector(
	selectOrganizationsState,
	(state) => state.positions,
);
export const selectPosition = createSelector(
	selectOrganizationsState,
	(state) => state.position,
);
export const selectPositionCloneId = createSelector(
	selectOrganizationsState,
	(state) => state.cloneId,
);
export const selectPolicies = createSelector(
	selectOrganizationsState,
	(state) => state.policies,
);
export const selectPolicy = createSelector(
	selectOrganizationsState,
	(state) => state.policy,
);
export const selectOrgList = createSelector(
	selectOrganizationsState,
	(state) => state.orgList,
);
export const selectGroupsList = createSelector(
	selectOrganizationsState,
	(state) => state.groupList,
);
export const selectCpfAvailability = createSelector(
	selectOrganizationsState,
	(state) => state.cpfAvailability,
);
export const selectEmailAvailability = createSelector(
	selectOrganizationsState,
	(state) => state.emailAvailability,
);
export const selectUsers = createSelector(
	selectOrganizationsState,
	(state) => state.users,
);
export const selectUser = createSelector(
	selectOrganizationsState,
	(state) => state.user,
);
export const selectCpfBeneficiario = createSelector(
	selectOrganizationsState,
	(state) => state.cpfBeneficiario,
);
export const selectUserData = createSelector(
	selectOrganizationsState,
	(state) => state.userData,
);
export const selectNewBeneCpf = createSelector(
	selectOrganizationsState,
	(state) => state.newBeneCpf,
);
export const selectCpfTitular = createSelector(
	selectOrganizationsState,
	(state) => state.cpfTitular,
);
export const selectCpfDependent = createSelector(
	selectOrganizationsState,
	(state) => state.cpfDependent,
);
export const selectEmailDependent = createSelector(
	selectOrganizationsState,
	(state) => state.emailDependent,
);
export const selectDepModalResult = createSelector(
	selectOrganizationsState,
	(state) => state.depModalResult,
);
export const selectDependentBenefits = createSelector(
	selectOrganizationsState,
	(state) => state.dependentBenefits,
);
// export const selectEditDependentBenefitsModalResult = createSelector(
// 	selectOrganizationsState,
// 	(state) => state.dependentBenefitsResult,
// );
export const selectBeneNewStatus = createSelector(
	selectOrganizationsState,
	(state) => state.beneNewStatus,
);
export const selectBeneficiaryFileURL = createSelector(
	selectOrganizationsState,
	(state) => state.beneficiaryFileURL,
);
export const selectBeneficiaryAllBenefits = createSelector(
	selectOrganizationsState,
	(state) => state.beneficiaryAllBenefits,
);
export const selectBeneficiaryAllPolicies = createSelector(
	selectOrganizationsState,
	(state) => state.beneficiaryAllPolicies,
);
export const selectEditPoliciesModalResult = createSelector(
	selectOrganizationsState,
	(state) => state.beneficiaryPoliciesResult,
);
export const selectNotificationsResult = createSelector(
	selectOrganizationsState,
	(state) => state.notifications,
);
export const selectXlsxUrl = createSelector(
	selectOrganizationsState,
	(state) => state.xlsxUrl,
);
export const selectScores = createSelector(
	selectOrganizationsState,
	(state) => state.scores,
);
export const selectScoreXlsxUrl = createSelector(
	selectOrganizationsState,
	(state) => state.scoreXlsxUrl,
);
export const selectDeleteStep = createSelector(
	selectOrganizationsState,
	(state) => state.deleteStep,
);
export const selectDashCharts = createSelector(
	selectOrganizationsState,
	(state) => state.dashCharts,
);
export const selectDashBeneInfo = createSelector(
	selectOrganizationsState,
	(state) => state.dashBeneInfo,
);
export const selectDashChartsUrls = createSelector(
	selectOrganizationsState,
	(state) => state.dashUrls,
);
export const selectDashChartUrl = createSelector(
	selectOrganizationsState,
	(state) => state.dashUrl,
);
export const selectOrgBeneficiariesDataURL = createSelector(
	selectOrganizationsState,
	(state) => state.orgBeneficiariesDataUrl,
);
export const selectOrgUploadFileResult = createSelector(
	selectOrganizationsState,
	(state) => state.beneficiariesBulkFileUploadResult,
);
export const selectOrgBatchActions = createSelector(
	selectOrganizationsState,
	(state) => state.batchActions,
);
export const selectOrgBatchActionInfo = createSelector(
	selectOrganizationsState,
	(state) => state.batchAction,
);
export const selectOrgBatchActionFileUrl = createSelector(
	selectOrganizationsState,
	(state) => state.batchActionFileUrl,
);
export const selectOrgProducts = createSelector(
	selectOrganizationsState,
	(state) => state.products,
);

export const selectOrgBatchActionLoadStatus = createSelector(
	selectOrganizationsState,
	(state: OrganizationsState) => state.batchActionLoadStatus,
);
